export const SPARTAN_PRODUCT_FEATURE_CAROUSEL_LABELS = {
  featureThumbnails: 'Feature thumbnails',
  playFeature: 'Play feature',
  pauseFeature: 'Pause feature',
} as const;
